import { defineComponent, h } from 'vue';
import { QCard, QCardSection, QCardActions, QSelect, QBtn, QSpace } from 'quasar';
import EventBus from '../../event-bus.js';
import utils from '../../../Shared/utils.jsx';

export default defineComponent({
    name: 'field-picker',
    components: { QCard, QCardSection, QCardActions, QSelect, QBtn, QSpace },
    data: () => ({
        filter: '',
        selected: {},
        choices: {},
        controls: null,
    }),
    props: {
        schema: null,
        confirm: null,
        cancel: null,
    },
    created() {
    },
    async mounted() {
        const formcontrol = await utils.schema.get('/Apps/Schema/AnyOf/schema/public/Platform.Schema.BaseTypes.v1/FormControl');
        if (formcontrol)
            this.controls = formcontrol.anyOf;
    },
    computed: {
    },
    methods: {
        returnControl() {
            const selected = {};
            for (let key in this.selected) {
                if (this.selected[key])
                    selected[key] = {
                        type: this.controls[this.choices[key]],
                    };
            }
            this.confirm(selected);
        },
        toggle(e, key) {
            this.selected[key] = e.target.checked;
        },
        selectAll(e) {
            if (!e.target.checked) {
                this.selected = {};
                return;
            }

            for (let key in this.schema.properties)
                this.selected[key] = true;
        },
    },
    render() {
        if (!this.controls)
            return <div>Loading...</div>;

        let defaultIndex = 0;
        const controlItems = [];
        for (let i = 0; i < this.controls.length; i++) {
            const c = this.controls[i];
            if (c.Id === "/schema/public/Platform.Schema.FormControls.v1/FormControl_AutoField")
                defaultIndex = i;

            controlItems.push({ text: c.title, value: i });
        }

        const items = [];
        for (let key in this.schema.properties) {
            const c = this.schema.properties[key];
            if (!(key in this.choices))
                this.choices[key] = defaultIndex;

            items.push(
                <tr>
                    <td><input type="checkbox" checked={this.selected[key]} onChange={(e) => this.toggle(e,key)} /></td>
                    <td>{key}</td>
                    <td>{c.type}</td>
                    <td style={{ minWidth: "145px" }} class="property-grid">
                        <QSelect filled dense hide-bottom-space
                            options={controlItems}
                            option-label="text"
                            option-value="value"
                            emit-value
                            map-options
                            modelValue={this.choices[key]}
                            style={{ minWidth: "160px", width: "100%" }}
                            onUpdate:modelValue={(value) => this.choices[key] = value} />
                    </td>
                    <td style={{ maxWidth: "220px" }}>{c.description}</td>
                </tr>
            );
        }

        return (
            <QCard>
                <QCardSection class="text-h6">Fields</QCardSection>
                <QCardSection>
                    <table id="tableFieldPicker" class="fieldpicker-table">
                        <tr style="background-color: blue; color: white;">
                            <th><input type="checkbox" onChange={(e) => this.selectAll(e)} /></th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Control</th>
                            <th>Description</th>
                        </tr>
                        {items}
                    </table>
                </QCardSection>
                <QCardActions align="right">
                    <QSpace />
                    <QBtn flat color="green-8" onClick={this.returnControl}>Add</QBtn>
                    <QBtn flat color="green-8" onClick={this.cancel}>Cancel</QBtn>
                </QCardActions>
            </QCard>
        );
    }
//                    <v-btn color="green darken-1" flat on-click={this.returnControl()}>Add</v-btn>
});